import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetWorkOrderBomListQuery, useGetWorkOrderItemListQuery } from '../../../../store/api/assemblyapi';
import ApiSelectSearch from '../../../../Core/Fields/Floating/ApiSelectSearch';
import { useGetWarehouseListMutation } from '../../../../store/api/purchaseorderapi';
import { useEffect, useState } from 'react';
import { usePostBomListSecondMutation } from '../../../../store/api/bomapi';

const Tab1 = ({ WOI,WOBOM,qty, podate, ponumber }) => {
  const {data:Bomdata} = useGetWorkOrderBomListQuery(WOI.selectWOItem);
  console.log("check bom data is here",Bomdata);
  const [getbomlist_data] = usePostBomListSecondMutation();

  useEffect(()=>{

    const getdata = async () =>{
      const formdata = new FormData;
      formdata.append("production_item",WOI.selectWOItem);
      const bomApiData = await getbomlist_data(formdata);
      console.log("check bom api list data",bomApiData);
      // setwarehouse_list(warehouseApiData.data.result);
    }

    if(WOI.selectWOItem){
      getdata();
    }
   
  },[WOI.selectWOItem])
  const [getwarehouse_data] = useGetWarehouseListMutation();
  const [warehouse_list,setwarehouse_list] = useState([]);
    useEffect(() => {
    const Warehouse = async () => {
      const warehouseApiData = await getwarehouse_data();
      setwarehouse_list(warehouseApiData.data.result);
    }
    Warehouse()
  }, [])

  return (
    <div className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px", borderRadius: "5px",height: '72vh', overflowY: 'scroll',flexWrap:'nowrap'}}>
     <div className="col-12">
      <div className="row">
      <div className="col-md-6 mt-1 mb-2" >
        <Input id="orderNo" label="No." readOnly value={ponumber} style={{ height: '30px' }} />
      </div>
      <div className="col-md-6 mt-1">
        <Input id="orderdatepo" type="date" style={{ height: '30px' }} label="Date" readOnly value={podate.podate} onChange={(e) => podate.setpodate(e.target.value)} />
      </div>
      </div>
     </div>
      <div className="col-12 ">
        <div className={WOI?.Error ? `mb-3 errorborder` : `mb-3`}>
        <ApiSelectSearch
        label="Item To Manufacture"
        placeholder=""
        value={WOI.selectWOItem}
        onChange={(v)=>WOI.setselectWOItem(v)}
        useQueryHook={useGetWorkOrderItemListQuery}
        getOptionLabel={(item) => item.name}
        getOptionValue={(item) => item.name}
        minSearchLength={2}
        />   
        </div>
      </div>
      <div className="col-12 ">
        <div className={WOBOM.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={Bomdata?.data}
            label="BOM No"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={WOBOM.selectWOBOM}
            onChange={(val) => WOBOM.setselectWOBOM(val)}
          />
        </div>
      </div>
      
      <div className="col-12 mb-2">
        <Input id="orderdatepo" type="number" style={{ height: '30px',border:qty.Error ? "1px solid red" : '' }} label="Qty To Manufacture" value={qty.QtyToManufacture} onChange={(e) => qty.setQtyToManufacture(e.target.value)} />
        
      </div>


{/* 
        <div className="col-12 ">
        <div className={WOBOM.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={warehouse_list}
            label="Work in Progress Warehouse"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={WOBOM.selectWOBOM}
            onChange={(val) => WOBOM.setselectWOBOM(val)}
          />
        </div>
      </div>



        <div className="col-12 ">
        <div className={WOBOM.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={warehouse_list}
            label="Target Warehouse"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={WOBOM.selectWOBOM}
            onChange={(val) => WOBOM.setselectWOBOM(val)}
          />
        </div>
      </div> */}
    


    </div>
  )
}

export default Tab1